export const BUCKET_OBJECTS_SETUP = 'BUCKET_OBJECTS_SETUP';
export function actionSetup({ Bucket, Prefix, MaxKeys, ContinuationToken }) {
    return {
        type: BUCKET_OBJECTS_SETUP,
        data: { Bucket, Prefix, MaxKeys, ContinuationToken },
    };
}
